import React from 'react';
import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { CheckCircle, AlertCircle, RefreshCw } from 'lucide-react';
import { useMetaTagFixer } from '../hooks/useMetaTagFixer';

const MetaTagManager: React.FC = () => {
  const { status, isFixing, fixMetaTags, hasIssues } = useMetaTagFixer();

  return (
    <Card className="w-full max-w-md">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <RefreshCw className="h-5 w-5" />
          Gerenciador de Meta Tags
        </CardTitle>
        <CardDescription>
          Corrige automaticamente meta tags deprecated do Canva
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {/* Status das Meta Tags */}
        <div className="space-y-2">
          {status.deprecated.length > 0 && (
            <div className="flex items-center gap-2">
              <AlertCircle className="h-4 w-4 text-red-500" />
              <span className="text-sm text-red-600">
                {status.deprecated.length} meta tag(s) deprecated encontrada(s)
              </span>
            </div>
          )}
          
          {status.correct.length > 0 && (
            <div className="flex items-center gap-2">
              <CheckCircle className="h-4 w-4 text-green-500" />
              <span className="text-sm text-green-600">
                Meta tag correta configurada
              </span>
            </div>
          )}
          
          {status.missing.length > 0 && (
            <div className="flex items-center gap-2">
              <AlertCircle className="h-4 w-4 text-yellow-500" />
              <span className="text-sm text-yellow-600">
                Meta tag correta não encontrada
              </span>
            </div>
          )}
        </div>

        {/* Badges de Status */}
        <div className="flex flex-wrap gap-2">
          {status.deprecated.map(tag => (
            <Badge key={tag} variant="destructive" className="text-xs">
              ❌ {tag}
            </Badge>
          ))}
          {status.correct.map(tag => (
            <Badge key={tag} variant="default" className="text-xs">
              ✅ {tag}
            </Badge>
          ))}
          {status.missing.map(tag => (
            <Badge key={tag} variant="secondary" className="text-xs">
              ⚠️ {tag}
            </Badge>
          ))}
        </div>

        {/* Botão de Correção */}
        {hasIssues && (
          <Button 
            onClick={fixMetaTags} 
            disabled={isFixing}
            className="w-full"
          >
            {isFixing ? (
              <>
                <RefreshCw className="h-4 w-4 mr-2 animate-spin" />
                Corrigindo...
              </>
            ) : (
              <>
                <CheckCircle className="h-4 w-4 mr-2" />
                Corrigir Meta Tags
              </>
            )}
          </Button>
        )}

        {!hasIssues && status.correct.length > 0 && (
          <div className="text-center text-sm text-green-600 bg-green-50 p-3 rounded-md">
            ✅ Todas as meta tags estão corretas!
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default MetaTagManager; 